import _ from 'underscore';
import { draftAlertStyles } from '@bingads-webui-campaign-react/gmc-to-mmc-mapping-grid-shared';

export const getOverrideStyles = () => ({
  '.adgroup-settings-container .bid-section': {
    marginTop: '-45px',
    paddingBottom: '15px',
  },
  '.adgroup-settings-container .advanced-settings-section': {
    marginTop: '42px',
  },
  '.adgroup-settings-container .audience-advanced-target-settings': {
    paddingTop: 0,
  },

  h1: {
    margin: '0 0 0 32px',
    fontSize: 20,
    color: '#323130',
  },

  '.radio.filteredProducts .helpbutton': {
    marginLeft: 5,
  },

  hr: {
    marginBottom: 1,
  },

  '#siteExclusionSettings .col-sm-3,#ipExclusionSettings .col-sm-3': {
    width: '100%',
  },

  '.audience-adgroup-settings-wizard-container .action-buttons-container.row': {
    height: 32,
    float: 'left',
    clear: 'both',
    marginBottom: 32,
  },

  h3: {
    borderTop: '1px solid #605E5C',
    fontFamily: 'Segoe UI',
    fontSize: '18px',
    lineHeight: '24px',
    marginBottom: '21px',
    paddingTop: '5px',
  },

  '.url-options > div > .form-group': {
    marginLeft: 0,
  },

  '.custom-param__close-button': {
    marginLeft: '5px',
  },

  '.audience-adgroup-targets-container': {
    paddingLeft: 0,
  },

  'span.level-toggle': {
    float: 'left',
    marginRight: '10px',
  },
  'span.bold': {
    fontWeight: 1000,
  },
  '.alert-budget-button': {
    marginLeft: '10px',
    paddingTop: '5px',
    '& button': {
      color: 'black',
      fontSize: '13px',
      fontWeight: 500,
      borderColor: '#edebe9',
    },
  },

  // DSA campaign Targeting source Page feeds search box
  '.pagefeed-selector-container .dlb-filter-alignPlaceholder': {
    paddingRight: 0,
  },

  'a.helpbutton': {
    fontWeight: 'normal',
    marginRight: '5px',
  },
  '.location-bid-grid-message': {
    marginRight: '7px',
  },
  '.setting-container .btn-save': {
    marginRight: '8.3px',
  },
  '.alert.alert-info.form-group.page-alert': {
    paddingBottom: '13px',
    width: '100%',
    marginBottom: '10px',
  },
  '.btn-primary': {
    marginRight: '10px',
  },
  '.displayNone': {
    display: 'none',
  },
  '.advanced-settings-section': {
    marginTop: '20px',

    '& .advanced-scheduling-grid .ad-scheduling-panel table': {
      '& tr:nth-child(3)': {
        '& .radio-inline:nth-child(2), .radio-inline:nth-child(3)': {
          left: 0,
        },
      },
    },
  },

  '.settings-view .campaign-settings__container .form-group:last-child .col-sm-2': {
    display: 'block',
  },
  '.settings-view .adgroup-settings .form-group:last-child .col-sm-2': {
    display: 'block',
  },

  'span.is-error': {
    color: 'red',
  },

  // Fix overlap of site exclusion setting and label after it
  '#siteExclusionSettings .col-sm-5': {
    width: 'auto',
  },
  '.all-settings-view hr': {
    visibility: 'hidden',
    marginTop: '1px',
  },

  '.toggle-campaign-settings-switch': {
    display: 'inline-block',
    float: 'left',
    marginRight: '10px',
  },
  '.update-container .advanced-settings-section': {
    marginTop: '34px',
  },
  // Fix Campaign Budget "USD | per day" misaligned
  '.container-budget > .row:first-child > .form-control-static': {
    paddingTop: '2px',
  },
  '.audience-target-settings-container .bid-adjustment-grids-container table tbody tr td': {
    '& select.form-control,input.form-control': {
      display: 'inline-block',
    },
  },

  '.campaign-settings__container .budget .container-budget .input-group .budget-amount': {
    width: '150px',
  },

  '.default-bid-container': {
    '& input.Amount-value': {
      width: '150px',
    },
    '& span.input-group-addon': {
      float: 'left',
    },
  },

  'input.searchbid.form-control': {
    width: '150px',
  },

  '.bidWarning': {
    marginTop: 6,
  },

  '.glyphicon-pencil': {
    marginRight: '5px',
  },

  '.form-horizontal .form-group': {
    marginRight: 0,
  },

  '.target-or-bid-selector-content label.radio-inline div': {
    display: 'inline-block',
  },

  '#TrackingTemplateErrors': {
    color: '#A80000',
  },

  // In campaign location targeting, the margin is broken
  '.btn-primary.location-target-done': {
    marginLeft: 15,
  },

  'input.form-control[disabled]': {
    color: '#a19f9d',
    cursor: 'default',
    background: '#F3F2F1',
  },

  // Fix website exclusions style
  '#siteExclusionSettings .row .pull-right': {
    float: 'none!important',
  },

  '.draft-store-alert-container .draft-store-alert': _.extend(
    draftAlertStyles({ iconFontFamily: {}, palette: {} }),
    {
      // Intentionally overriding the width to match the styling of other alerts on this page
      maxWidth: '1070px',
      marginTop: '35px',
      marginLeft: '15px',
    }
  ),
});
